import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { array, func } from 'prop-types';
import FlowPostbackStatus from '@components/Flow/FlowPostbackStatus';
import CustomControl from '@components/CustomControl/CustomControl';
import Hint from '@components/Hint/Hint';
import { FHTMLMessage, FMessage } from '@hoc/IntlComponents';
import { injectIntl, intlShape } from 'react-intl';

const GENERATE_CONVERSION_STATUS = 2;

class FlowPostbackStatuses extends PureComponent {
  static propTypes = {
    statuses: array.isRequired,
    selected: array.isRequired,
    onStatusChange: func.isRequired,
    intl: intlShape.isRequired,
  };

  static defaultProps = {
    statuses: [],
    selected: [GENERATE_CONVERSION_STATUS],
    onStatusChange() {},
  };

  state = {
    enabled: true,
    statuses: [],
  };

  componentDidMount() {
    const statuses = this.props.statuses.map(status => ({
      ...status,
      title: this.props.intl.formatMessage({
        id: `flow.form.postback.statuses.${status.id}.theme_4`,
        defaultMessage: status.title,
      }),
    }));

    this.setState(() => ({ statuses }));
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState(() => ({
      enabled: nextProps.selected.length !== 0,
    }));
  }

  toggleExtraStatuses = () => {
    this.setState(
      prevState => ({
        enabled: !prevState.enabled,
      }),
      () => {
        if (!this.state.enabled) {
          this.props.onStatusChange([]);
        } else {
          this.selectAllStatuses();
        }
      },
    );
  };

  handleChange = ({ target }) => {
    const id = parseInt(target.value, 10);
    const { selected } = this.props;
    if (selected.includes(id)) {
      this.props.onStatusChange(selected.filter(status => status !== id));
    } else {
      this.props.onStatusChange([...selected, id]);
      this.setState(() => ({ enabled: true }));
    }
  };

  selectAllStatuses = () => this.props.onStatusChange(this.props.statuses.map(status => status.id));

  render() {
    const { selected } = this.props;
    const { statuses } = this.state;
    return (
      <div className="postback-statuses">
        <ul className="flow-postback-statuses">
          {statuses.map(({ id, title }) => (
            <FlowPostbackStatus
              key={id}
              onChange={this.handleChange}
              label={title}
              status={id}
              checked={selected.includes(id)}
            />
          ))}
        </ul>
      </div>
    );
  }
}

export default injectIntl(FlowPostbackStatuses);
